import { WebsiteType } from "app/pages/sales-intelligence/domain/leads/types/enums";

export const TO_API: Partial<Record<WebsiteType, WebsiteType>> = {
    [WebsiteType.EcommerceDtc]: WebsiteType.EcommerceOther,
    [WebsiteType.EcommerceRetailer]: WebsiteType.EcommerceOther,
};

export const FROM_API_EXCLUDE_VALUE = WebsiteType.EcommerceOther;
